<template>
  <div :class="$style.container">
    <div :class="$style.phoneType">{{phone.type}}</div>
    <div :class="$style.phoneNumber">{{phone.nationalFormat}}</div>
    
    <ContactButtons :contact="contact" :phone="phone" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPhone } from '@fortawesome/pro-solid-svg-icons/faPhone'
import { faMobileAlt } from '@fortawesome/pro-solid-svg-icons/faMobileAlt'
import { faCommentLines } from '@fortawesome/pro-solid-svg-icons/faCommentLines'
import ContactButtons from '@/components/shared/ContactButtons'

const { mapGetters } = createNamespacedHelpers('dialer')

export default {
  components: {
    FontAwesomeIcon,
    ContactButtons
  },
  props: {
    contact: {
      required: true,
      type: Object
    },
    phone: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      faPhone,
      faMobileAlt,
      faCommentLines,
      phoneType: 'JIMINNY.SOFTPHONE.PHONE',
      mobileType: 'JIMINNY.SOFTPHONE.MOBILE',
      smsType: 'JIMINNY.SMS'
    }
  },
  computed: {
    ...mapGetters([
      'hasDial',
      'hasSms'
    ])
  },
  methods: {
    dispatch (phone, type) {
      this.$router.push({
        path: 'phone-controller',
        query: {
          type: encodeURIComponent(type),
          phone: encodeURIComponent(phone.number),
          recordId1: encodeURIComponent(this.contact.crmId),
          objectType: encodeURIComponent(this.contact.prospectType)
        }
      })
    }
  }
}
</script>

<style module lang="less" src="./PhoneNumber.less"></style>



// WEBPACK FOOTER //
// PhoneNumber.vue?516b89cc